import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { ChannelPill } from '../components/ChannelPill'
import { Icon } from '../components/Icon'
import type { ChannelConfig } from '../types'
import styles from './ChannelList.module.css'

interface Props {
  channels: ChannelConfig[]
  loading: boolean
  error: string | null
}

export function ChannelList({ channels, loading, error }: Props) {
  const [query, setQuery] = useState('')
  const navigate = useNavigate()
  const listRef = useRef<HTMLDivElement>(null)

  const filtered = query
    ? channels.filter(c =>
        c.channelName.toLowerCase().includes(query.toLowerCase()) ||
        c.prefix.toLowerCase().includes(query.toLowerCase()),
      )
    : channels

  function openChannel(channelId: string) {
    if (listRef.current) {
      listRef.current.style.animation = 'fadeOutList .18s ease forwards'
    }
    setTimeout(() => navigate(`/channels/${channelId}`), 160)
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div>
          <div className={styles.title}>Your Channels</div>
          <div className={styles.sub}>
            Review Ops is active in {channels.length} channel{channels.length !== 1 ? 's' : ''} you're a member of
          </div>
        </div>
      </div>

      <div className={styles.searchRow}>
        <div className={styles.searchWrap}>
          <Icon name="search" size="sm" className={styles.searchIcon} />
          <input
            type="search"
            placeholder="Search channels"
            value={query}
            onChange={e => setQuery(e.target.value)}
            className={styles.searchInput}
          />
        </div>
      </div>

      <div className={styles.grid} ref={listRef}>
        {loading && <div className={styles.state}>Loading channels…</div>}
        {error && <div className={styles.stateError}>{error}</div>}
        {!loading && !error && filtered.length === 0 && (
          <div className={styles.state}>
            {query ? 'No channels match your search.' : 'No channels configured yet.'}
          </div>
        )}
        {filtered.map(ch => (
          <div key={ch.channelId} onClick={() => openChannel(ch.channelId)}>
            <ChannelPill channel={ch} />
          </div>
        ))}
      </div>
    </div>
  )
}
